<template>
    <div class="flex items-center mb3">
        <div class="w-40 mr3">
        <CurrencyInput :value="value" @input="$emit('input', $event)" class=""/>
        </div>
        <div class="flex">
            <h6>/</h6>
            <h6 class="ml3">Day</h6>
        </div>
    </div>
</template>

<script>
import CurrencyInput from '@/components/controls/CurrencyInput.vue';

export default {
    components: {
        CurrencyInput
    },
    props: {
        value: {
            type: Number
        }
    }
};
</script>
